// extracted by mini-css-extract-plugin
export default {"button":"RoundedButtonExpanded_button__y+Wv0"};